var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from '@cvent/nucleus-dynamic-css';
import { resolveTestId } from '@cvent/nucleus-test-automation';
/**
# FlipCounter Component
**/
var FlipCounter = /** @class */ (function (_super) {
    __extends(FlipCounter, _super);
    function FlipCounter(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            flipping: false
        };
        return _this;
    }
    FlipCounter.prototype.componentDidMount = function () {
        var _this = this;
        setTimeout(function () {
            _this.setState({
                flipping: true
            });
        });
    };
    FlipCounter.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        /* eslint-disable react/no-did-update-set-state */
        // Need to verify if both not numbers becuase equality does not check this.
        if (isNaN(prevProps.digit) && isNaN(this.props.digit)) {
            return;
        }
        if (prevProps.digit === this.props.digit) {
            return;
        }
        this.setState({
            flipping: false
        });
        setTimeout(function () { return _this.setState({
            flipping: true
        }); }, 20);
    };
    FlipCounter.prototype.render = function () {
        return React.createElement("li", __assign({}, resolveTestId(this.props), resolve(this.props, 'counter')),
            React.createElement("div", __assign({}, resolve(this.props, 'wrapper')),
                React.createElement("div", __assign({}, resolve(this.props, 'digitWrapper')),
                    React.createElement("div", __assign({}, resolve(this.props, 'current', 'top', 'flip', this.state.flipping ? 'flipping' : '')),
                        React.createElement("div", __assign({}, resolve(this.props, 'digitTop')),
                            React.createElement("span", null, this.props.digit + 1 === 60 ? 0 : this.props.digit + 1))),
                    React.createElement("div", __assign({}, resolve(this.props, 'next', 'top', 'flip')),
                        React.createElement("div", __assign({}, resolve(this.props, 'digitTop')),
                            React.createElement("span", null, this.props.digit))),
                    React.createElement("div", __assign({}, resolve(this.props, 'current', 'bottom', 'flip')),
                        React.createElement("div", __assign({}, resolve(this.props, 'digit')),
                            React.createElement("span", null, this.props.digit + 1 === 60 ? 0 : this.props.digit + 1))),
                    React.createElement("div", __assign({}, resolve(this.props, 'next', 'bottom', 'flip', this.state.flipping ? 'flipping' : '')),
                        React.createElement("div", __assign({}, resolve(this.props, 'digit')),
                            React.createElement("span", null, this.props.digit))))),
            React.createElement("span", __assign({}, resolve(this.props, 'label')), this.props.label));
    };
    FlipCounter.displayName = 'FlipCounter';
    FlipCounter.propTypes = {
        /** Label text for the counter. */
        label: PropTypes.string,
        /** The actual value to display in the counter. */
        digit: PropTypes.number.isRequired,
        /** Available Style Keys. */
        style: PropTypes.shape({
            /** Top level style applied to the container. */
            counter: PropTypes.object,
            /** Style applied to the wrapper around the digit part of the counter. */
            wrapper: PropTypes.object,
            /** Style applied to the digit part of the counter. */
            digitWrapper: PropTypes.object,
            /** Style applied to the digit. */
            current: PropTypes.object,
            /** Style applied to the digit. */
            top: PropTypes.object,
            /** Style applied to the digit. */
            flip: PropTypes.object,
            /** Style applied to the digit. */
            flipping: PropTypes.object,
            /** Style applied to the digit. */
            digitTop: PropTypes.object,
            /** Style applied to the digit. */
            next: PropTypes.object,
            /** Style applied to the digit. */
            bottom: PropTypes.object,
            /** Style applied to the digit. */
            digit: PropTypes.object,
            /** Style applied to the label part of the counter. */
            label: PropTypes.object
        })
    };
    return FlipCounter;
}(React.Component));
export default FlipCounter;
